export default function startNumFilter() {
    return function (input) {
        if (input === null || input === undefined) return input
        if (input.length < 8) {
            for (let i = 0; i < 8 - input.length;) {
                input = `0${input}`
            }
        }
        return input
    }
}



// WEBPACK FOOTER //
// ./src/common/services/startNumFilter.js